<template>
    <div class="campaign-card connect-campaign" :class="props.mode == 'big' ? 'campaign-connect-fullscreen' : '' ">
        <!-- Dark Overlay -->
        <div v-if="props.mode == 'big'" class="dark-cover"></div>
        <div class="campaign-connect-wrapper">
            <div class="header" >
                <img
                    :src="
                    campaign.image_id
                        ? getImage(campaign.image_id)
                        : getRandomCampaignPicture(campaign.public_name)
                    "
                    alt="Campaign header"
                    ref="image"
                    :class="props.mode == 'big' ? 'campaign-header-big' : 'campaign-header-small' "
                />  
                <label  v-if="props.mode == 'small'" class="btn connect-campaign-size-bt "  :style="getThemeStyle(campaign)" @click="toggleViewSize">
                    <i class="bi bi-arrows-fullscreen" />
                </label>       
                <label  v-else class="btn connect-campaign-size-bt" :style="getThemeStyle(campaign)" @click="toggleViewSize">
                    <i class="bi bi-fullscreen-exit" />
                </label>
            </div>
            <div class="body">
            <div class="name-duration-row">
                <div class="block">
                <h4 class="card-title" v-text="campaign.public_name" />
                <p class="job" v-text="campaign.job_title" />
                </div>
                <div class="informations-container">
                <div class="tag-container">
                    <div class="tag" :style="getThemeStyle(campaign)">TEMPS MOYEN: {{ duration }} MIN</div>
                </div>
                </div>
            </div>
            <p class="campaign-description" :class="props.mode == 'big' ? 'campaign-description-big' : '' " v-html="campaign.job_description" />
            <Button 
                class="icon icon-left primary full-size"
                :style="getThemeStyle(campaign)"
                label="Je m'inscris pour débuter l'aventure !"
                icon="bi-shield-lock"
                @click="connectBt"
            />
            </div>

        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { getImage, getRandomCampaignPicture } from "@/composables/getImage.js";

const emits = defineEmits([ "toggleViewSize", "connectPress"]);

var props = defineProps({
    campaign: {
        type: Object,
    },
    mode:{
        type: String,
    },
});

function getThemeStyle (campaign) {
  if(!campaign) {
    return '';
  }

  var bgColour = "#f2cb36";
  var textColour = "#000000";

  return {
  'background-color': campaign.elem_colour ? campaign.elem_colour : bgColour,
  'color': campaign.text_colour ? campaign.text_colour : textColour,
  };
}

function toggleViewSize(){
    emits("toggleViewSize");
}

function connectBt(){
    console.log("connectBt");
    emits("connectPress");
    
}

const duration = computed<number>(() => {
  const version = getVersionObjectFromVersionID(props.campaign.calibration_id);
  if (version) return version.duration;
  return 50;
});
</script>

<style scoped>
.connect-campaign {
    width: 50%!important;
    min-width: 400px;
    padding: 18px;
}
.connect-campaign-size-bt {    
  position: relative; 
  display: flex;
  align-items: center;
  padding: 10px!important;
  border-radius: 4px;
  border: 2px solid;
  border-color: #464646!important;
  top: 20px;
  margin-right: 14px;
}

.campaign-description-big {
    min-height: 35svh!important;
    max-height: 35svh!important;
}

.campaign-header-small {
    margin-bottom: -4px;
}

.campaign-header-big {
    min-height: 18svh!important;
    max-height: 18svh!important;
    margin-bottom: -4px;
}


.campaign-connect-fullscreen{
  position: absolute;
  z-index: 11; /* Above the dark overlay */
  transition: transform 0.3s ease;
  min-width: 60%!important;
  max-width: 180px!important;
  justify-content: center!important;
  align-items: center!important;
  left: 20%!important;
  
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}


/* CampaignConnect Wrapper */
.campaign-connect-wrapper {
  position: relative;
  z-index: 11; /* Above the dark overlay */
  transition: transform 0.3s ease;
}


/* Dark overlay */
.dark-cover {
  position: fixed;
  width: 300vw;
  height: 300vh;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 10;
  left: -100%!important;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

</style>